import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../../../../node_modules/pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../../styles/LandingPageStyles';

export const FormContainer = styled.form`
    background-color: ${colors.miscLightGrey};
    border-radius: 2px;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
    display: block;
    

    .legal-footer {
        color: ${colors.grayscaleCoolGray06};
        font-size: 12px;
        margin: 20px 0;

        a {
            color: ${colors.grayscaleCoolGray06};
            letter-spacing: -0.3px;
            line-height: 1.33;
            text-decoration: underline;
        }
    }
    
    
    /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        margin-top: -176px;
        padding-bottom: 38px;
        width: 420px;

        .heading-component > h4 {
            font-size: 18px;
            letter-spacing: -.2px;
            line-height: 1.3;
            margin-bottom: 0;
            margin-left: 34px;
            margin-top: 28px;
            padding-right: 20px;
        }

        .body-copy-component {
            display: inline-block;
            font-size: 16px;
            letter-spacing: -.3px;
            line-height: 1.45;
            margin-left: 35px;
            margin-top: 5px;
            padding-right: 45px;
        }
        
        .marketing-form {
            margin-top: 0px;
        }

        .name-group, .zip-group {
            display: table;

            & > div {
                display: table-cell;
                padding-left: 0;
                padding-right: 0;
                width: 50%;

                &:first-child {
                    padding-right: 10px;
                }

                &:last-child {
                    padding-left: 10px;
                }
            }
        }

        .button-wrap {
            margin-top: 35px;
            padding-left: 35px;
            padding-right: 33px;

            button {
                padding-top: 19px;
                width: 100%;
            }
        }

        .legal-footer {
            letter-spacing: -.3px;
            line-height: 1.4;
            padding-left: 35px;
            padding-right: 35px;
       }
    }

     /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        margin-top: -121px;
        padding-bottom: 23px;
        width: 325px;

        .heading-component > h4 {
            font-size: 18px;
            letter-spacing: -.2px;
            line-height: 1.3;
            margin-bottom: 0;
            margin-left: 22px;
            margin-top: 27px;
            padding-right: 20px;
        }

        .body-copy-component {
            display: inline-block;
            font-size: 16px;
            letter-spacing: -.3px;
            line-height: 1.45;
            margin-left: 21px;
            margin-bottom: 10px;
            margin-top: 7px;
            padding-right: 20px;
        }
        
        .marketing-form {
            margin-top: 0px;
        }

        .name-group, .zip-group {
            display: table;

            & > div {
                display: table-cell;
                padding-left: 0;
                padding-right: 0;
                width: 50%;

                &:first-child {
                    padding-right: 7px;
                }

                &:last-child {
                    padding-left: 7px;
                }
            }
        }

        .button-wrap {
            margin-top: 35px;
            padding-left: 18px;
            padding-right: 23px;

            button {
                padding-top: 18px;
                width: 100%;
            }
        }

        .legal-footer {
            letter-spacing: -.3px;
            line-height: 1.4;
            padding-left: 20px;
            padding-right: 20px;
       }
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        margin-top: 10px;
        padding-bottom: 23px;
        margin-bottom: 50px;
        width: 100%;

        .heading-component > h4 {
            font-size: 18px;
            letter-spacing: -1.10px;
            line-height: 1.3;
            margin-bottom: 0;
            margin-left: 22px;
            margin-top: 33px;
            padding-right: 20px;
        }

        .body-copy-component {
            display: inline-block;
            font-size: 16px;
            letter-spacing: -.3px;
            line-height: 1.4;
            margin-left: 23px;
            margin-bottom: 16px;
            margin-top: 3px;
            padding-right: 20px;
        }
        
        .marketing-form {
            margin-top: 0px;
        }

        .name-group, .zip-group {
            display: table;

            & > div {
                display: table-cell;
                padding-left: 0;
                padding-right: 0;
                width: 50%;

                &:first-child {
                    padding-right: 7px;
                }

                &:last-child {
                    padding-left: 7px;
                }
            }
        }

        .button-wrap {
            margin-top: 35px;
            padding-left: 18px;
            padding-right: 23px;

            button {
                padding-top: 18px;
                width: 100%;
            }
        }

        .legal-footer {
            letter-spacing: -.3px;
            line-height: 1.4;
            padding-left: 20px;
            padding-right: 20px;
       }
    }
`;
FormContainer.propTypes = {
    expanded: PropTypes.bool
};
export default FormContainer;


// WEBPACK FOOTER //
// ./src/components/Form/styles/FormContainer.js